module.exports = __webpack_public_path__ + "static/media/Hangua.a20ab6b2.jpg";